var _rect, _path, _path2, _path3, _path4, _circle, _g, _path5, _circle2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDevops = function SvgDevops(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.895,
    width: 27.106,
    height: 21.6,
    rx: 2,
    fill: "url(#devops_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.677,
    fill: "url(#devops_svg__b)",
    d: "M18.636 4.822h2.569V18.31h-2.569z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.677,
    fill: "url(#devops_svg__c)",
    d: "M12.706 2.965h2.569v13.488h-2.569z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.677,
    fill: "url(#devops_svg__d)",
    d: "M24.564 7.363h2.569v8.992h-2.569z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.677,
    fill: "url(#devops_svg__e)",
    d: "M30.494 4.822h2.569V18.31h-2.569z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.553,
    cy: 22.447,
    r: 13.553,
    fill: "url(#devops_svg__f)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#6E4FBD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.934 28.915h5.035v.535H6.934zM14.958 28.915h5.035v.535h-5.035zM13.325 24.646h.654v3.226h-.654z"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.892 18.797c0-.085.021-.149.021-.234a2.87 2.87 0 0 0-2.88-2.882c-.684 0-1.303.235-1.815.64-.726-1.387-2.177-2.347-3.842-2.347a4.336 4.336 0 0 0-4.332 4.332c0 .171 0 .32.02.491a3.506 3.506 0 0 0-3.18 3.5c0 1.943 1.58 3.501 3.501 3.501h12.336c1.943 0 3.5-1.58 3.5-3.5a3.498 3.498 0 0 0-3.329-3.5Z",
    fill: "url(#devops_svg__g)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.552,
    cy: 29.234,
    r: 1.686,
    fill: "url(#devops_svg__h)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "devops_svg__a",
    x1: 14.514,
    y1: -10.251,
    x2: -1.209,
    y2: 24.724,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DACFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8146FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "devops_svg__b",
    x1: 22.413,
    y1: 18.309,
    x2: 22.413,
    y2: -7.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A29C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC93FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "devops_svg__c",
    x1: 16.484,
    y1: 16.452,
    x2: 16.484,
    y2: -9.726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A29C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC93FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "devops_svg__d",
    x1: 28.342,
    y1: 16.355,
    x2: 28.342,
    y2: -1.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A29C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC93FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "devops_svg__e",
    x1: 34.272,
    y1: 18.309,
    x2: 34.272,
    y2: -7.869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A29C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC93FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "devops_svg__f",
    x1: -12.007,
    y1: 27.6,
    x2: 19.221,
    y2: 51.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFD5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC8BF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "devops_svg__g",
    x1: -20.918,
    y1: 19.512,
    x2: -8.056,
    y2: 44.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7C6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6536E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "devops_svg__h",
    x1: 9.407,
    y1: 28.937,
    x2: 12.185,
    y2: 33.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D7C6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6536E2"
  })))));
};
export { SvgDevops as ReactComponent };
export default "data:image/svg+xml;base64,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";